import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '../loader/loader.component';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  imports: [NgClass, LoaderComponent, TranslateModule, RouterLink],
})
export class ButtonComponent {
  @Input() name: string = '';
  @Input() classBtn: string = '';
  @Input() disableBtn: string = '';
  @Input() typeBtn: string = 'submit';
  @Input() isLoading = false;
  @Input() link: string | undefined;
  @Input() fragment: string | undefined;
  @Output() clickBtn = new EventEmitter<void>();
}
